import { render, staticRenderFns } from "./stockOverflowTask.vue?vue&type=template&id=65e9d8ec&scoped=true"
import script from "./stockOverflowTask.vue?vue&type=script&lang=js"
export * from "./stockOverflowTask.vue?vue&type=script&lang=js"
import style0 from "./stockOverflowTask.vue?vue&type=style&index=0&id=65e9d8ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e9d8ec",
  null
  
)

export default component.exports